import "./logo.css";
import WhiteLogo from "./logo-white.svg";

export function Logo() {
    return <img className="audette-logo" alt="Audette Logo" src={WhiteLogo} />;
}
